<template>
  <div class="index_user">
    <h3>访问的页面不存在</h3>
    <el-button type="danger" size="mini" @click="toIndex">点击返回首页</el-button>
  </div>
</template>

<script>
  export default {
    name: "notfound",
    data() {
      return {
        isMp: this.$browserType
      }
    },
    methods: {
      toIndex(){
        this.$router.push('/');
      }
    }
  }
</script>

<style scoped>
  .index_user {
    position: absolute;
    top:0;
    left:0;
    padding:0;
    margin:0;
    height: 100vh;
    line-height:40vh;
    width: 100%;
    background: linear-gradient(to bottom,#ad302a,#2f6bcd);
    color:white;
    text-align:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/notfound.vue